'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import styled, { mediaQuery, css } from '../../utils/Styling';
import { LEARNING_PAGE_SIDEBAR_WIDTH } from './LearningPageSidebar';
const FullHeightScrollable = styled.div.withConfig({
  displayName: "LearningPageMainSection__FullHeightScrollable",
  componentId: "md5383-0"
})(["flex-grow:1;overflow:hidden;"]);
const MaxWidth = styled.div.withConfig({
  displayName: "LearningPageMainSection__MaxWidth",
  componentId: "md5383-1"
})(["max-width:100vw;margin-left:auto;margin-right:auto;padding:0;", ""], mediaQuery('notTablet', css(["max-width:1180px;width:calc(100vw - ", "px);"], LEARNING_PAGE_SIDEBAR_WIDTH)));

const LearningPageMainSection = ({
  children
}) => /*#__PURE__*/_jsx(FullHeightScrollable, {
  children: /*#__PURE__*/_jsx(MaxWidth, {
    children: children
  })
});

export default LearningPageMainSection;